import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material';
import { RegistrationFormDialogComponent } from '../dialog/registration-form-dialog.component';

@Component({
  selector: 'app-registration-button',
  templateUrl: './registration-button.component.html',
  styleUrls: ['./registration-button.component.scss']
})
export class RegistrationButtonComponent implements OnInit {

  constructor(private dialog: MatDialog) { }

  @Input() gameData: any;

  ngOnInit() {
  }

  openDialog() {
    const dialogRef = this.dialog.open(RegistrationFormDialogComponent, {
      panelClass: 'registration-form-dialog',
      width: '850px',
      height: 'auto',
      data: {
        registrationFormConfig: {
          registrationForm: (this.gameData && this.gameData.registrationForm) || undefined
        }
      }
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (!response) return;
      if (this.gameData) {
        this.gameData.registrationForm = response.registrationForm;
      }
    });
  }

}
